import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-picked-card',
  templateUrl: './turns-reports-picked-card.component.html',
  styleUrls: ['./turns-reports-picked-card.component.scss']
})
export class TurnsReportsPickedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
